// extracted by mini-css-extract-plugin
export var button = "styles-module--button--d143a";
export var chatBlue = "styles-module--chatBlue--101f9";
export var chatGreen = "styles-module--chatGreen--cfeb0";
export var grBlueGreen = "styles-module--grBlueGreen--586ae";
export var light = "styles-module--light--d9583";
export var lighter = "styles-module--lighter--e5b56";
export var link = "styles-module--link--4cad2";
export var medium = "styles-module--medium--2c423";
export var olBlue = "styles-module--olBlue--b6544";
export var olGray = "styles-module--olGray--54539";
export var olGreen = "styles-module--olGreen--30293";
export var olRed = "styles-module--olRed--bd7b8";
export var outline = "styles-module--outline--2a6a5";
export var primary = "styles-module--primary--01e23";
export var short = "styles-module--short--38636";
export var tall = "styles-module--tall--247c5";
export var text = "styles-module--text--87fa5";
export var underline = "styles-module--underline--f145d";